// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__w9tBU","avatar":"style_avatar__3PSzm","menuIcon":"style_menuIcon__35KBa"};